import { useEffect, useState } from "react";

import { getDashboard } from "../services/adminBlogService";

export default function useDashboard() {

  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  useEffect(() => {

    loadDashboard();

  }, []);

  const loadDashboard = async () => {

    try {

      const response = await getDashboard();

      setData(response);

    } catch (err) {

      setError(err);

    } finally {

      setLoading(false);

    }
  };

  return {
    data,
    loading,
    error,
    reload: loadDashboard,
  };
}